import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Typography } from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';

const { Text } = Typography;

const ModalComparacionTramite = ({
  visible,
  onClose,
  titulo = 'Comparación de Información',
  inicial = {},
  final = {},
}) => {
  const formatearValor = (valor) => {
    if (valor === null || valor === undefined) return '—';
    if (Array.isArray(valor)) {
      if (valor.length === 0) return '—';
      if (valor[0]?.descripcion) {
        return valor.map((p) => p.descripcion || p.nombre_completo).join(', ');
      }
      return valor.map((v) => formatearValor(v)).join(', ');
    }
    if (typeof valor === 'object' && valor !== null) {
      if (valor.calle_principal && valor.codigo_postal) {
        const calle = valor.calle_principal || '';
        const numero = valor.numero_exterior || '';
        const colonia = valor.codigo_postal?.d_asenta || '';
        const municipio = valor.codigo_postal?.municipio?.nom_mun || '';
        const estado = valor.codigo_postal?.municipio?.estado?.nombre_de_AGEE || '';
        const pais = valor.codigo_postal?.municipio?.estado?.pais?.descripcion || '';

        return `${calle} ${numero}, ${colonia}, ${municipio}, ${estado}, ${pais}`;
      }

      if (valor.nombre_completo || valor.curp || valor.clave) {
        return `${valor.nombre_completo || ''}${valor.curp ? ` | ${valor.curp}` : ''}${valor.clave ? ` | ${valor.clave}` : ''}`;
      }

      return JSON.stringify(valor);
    }

    return String(valor);
  };

  const getCamposUnicos = (obj1, obj2) => Array.from(new Set([
    ...Object.keys(obj1 || {}),
    ...Object.keys(obj2 || {}),
  ]));

  const dataSource = getCamposUnicos(inicial, final)
    .map((key, index) => {
      const valorInicial = inicial?.[key];
      const valorFinal = final?.[key];
      const formateadoInicial = formatearValor(valorInicial);
      const formateadoFinal = formatearValor(valorFinal);

      const campoFormateado = key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

      return {
        key: index,
        campo: campoFormateado,
        valor_inicial: formateadoInicial,
        valor_final: formateadoFinal,
        haCambiado: JSON.stringify(valorInicial) !== JSON.stringify(valorFinal),
        ocultar: formateadoInicial === '—' && formateadoFinal === '—',
      };
    });

  const columns = [
    {
      titleText: 'Campo',
      dataIndex: 'campo',
      key: 'campo',
      width: '30%',
      render: (value) => <Text strong>{value}</Text>,
    },
    {
      titleText: 'Valor Inicial',
      dataIndex: 'valor_inicial',
      key: 'valor_inicial',
      width: '35%',
      render: (value) => <Text>{value}</Text>,
    },
    {
      titleText: 'Valor Final',
      dataIndex: 'valor_final',
      key: 'valor_final',
      width: '35%',
      render: (value, row) => (
        row.haCambiado
          ? <Text type="danger">{value}</Text>
          : <Text>{value}</Text>
      ),
    },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      onOk={onClose}
      title={<FormSubmitControls onCancel={onClose} label={titulo} />}
      width="100%"
      footer={null}
      closable={false}
    >
      <Table
        data={dataSource.filter((row) => !row.ocultar)}
        cols={columns}
        pagination={false}
        scroll={{ y: 450 }}
        noControls
        allowSort={false}
      />
    </Modal>
  );
};

ModalComparacionTramite.defaultProps = {
  titulo: 'Comparación de Información',
  inicial: {},
  final: {},
};

ModalComparacionTramite.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  titulo: PropTypes.string,
  inicial: PropTypes.shape({}),
  final: PropTypes.shape({}),
};

export default ModalComparacionTramite;
